import store from '@/store/store';

class IntervalController {
  public static cancelRPUIntervalReload() {
    const RPUIntervalId = store.getters.intervalRPUReloadId;
    if (RPUIntervalId) {
      clearInterval(RPUIntervalId);

      /* Log */
      console.log('Intervalo de atualização desfeito.');
    }
  }
}

export default IntervalController;
